import React, { useEffect } from 'react'
import IconLibraryBooks from '@material-ui/icons/LibraryBooks'
import IconExpandLess from '@material-ui/icons/ExpandLess'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import "./sidebar.scss";
import DashboardIcon from "@mui/icons-material/Dashboard";
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined';
import { Link } from "react-router-dom";
import { DarkModeContext } from "../../context/darkModeContext";
import { useContext } from "react";
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import Collapse from '@material-ui/core/Collapse'
import IconExpandMore from '@material-ui/icons/ExpandMore'
import { Permission } from "./userPermission";

const drawerWidth = 240

const useStyles = makeStyles(theme =>
  createStyles({
    appMenu: {
      width: '100%',
    },
    navList: {
      width: drawerWidth,
    },
    menuItem: {
      width: drawerWidth,
    },
    menuItemIcon: {
      color: '#97c05c',
    },
  }),
)

const Sidebar = () => {
  const { dispatch } = useContext(DarkModeContext);
  const classes = useStyles()
  const [open, setOpen] = React.useState(false)
  const [openMaster, setMasterOpen] = React.useState(false);
  const [openPharamacy, setPharamacyOpen] = React.useState(false);
  const [openAccounts, setAccountsOpen] = React.useState(false);
  const [openReports, setReportsOpen] = React.useState(false);
  const [menuPermission, setMenuPermission] = React.useState([]);
  const [pathologyOpen, setPathologyOpen] = React.useState(false);
  
  function handleClick() {
    setOpen(!open)
  }
  function handleMasterClick() {
    setMasterOpen(!openMaster)
  }

  function handlePharmacyClick() {
    setPharamacyOpen(!openPharamacy)
  }
  function handleAccountsClick() {
    setAccountsOpen(!openAccounts)
  }

  function handleReportsClick() {
    setReportsOpen(!openReports)
  }

  function handlePathologyClick(){
    setPathologyOpen(!pathologyOpen)
  }
  
  useEffect(() => {
    const filteredUsers = Permission?.filter(user => user.Role === JSON.parse(sessionStorage.getItem("loginDetails"))?.userGroup);
    setMenuPermission(filteredUsers)
  }, [JSON.parse(sessionStorage.getItem("loginDetails"))?.userGroup]);
 

  const MenuPermission = menuPermission && menuPermission[0]?.Menus
    .find(fruit => fruit?.MenuName === "Master");

  const patientMenuPermission = menuPermission && menuPermission[0]?.Menus
    .find(fruit => fruit?.MenuName === "Patient");

  const accountMenuPermission = menuPermission && menuPermission[0]?.Menus
    .find(fruit => fruit?.MenuName === "Account");
  const reportMenuPermission = menuPermission && menuPermission[0]?.Menus
    .find(fruit => fruit?.MenuName === "Report");
  const ipdMenuPermission = menuPermission && menuPermission[0]?.Menus
    .find(fruit => fruit?.MenuName === "IPD");

  const opdMenuPermission = menuPermission && menuPermission[0]?.Menus
    .find(fruit => fruit?.MenuName === "OPD");
  return (
    <div className="sidebar">
      <div className="top">
        <Link to="/home" style={{ textDecoration: "none" }}>
          <span className="logo">AROGYANXT</span>
        </Link>
      </div>
      <hr />
      <div className="center">
        <ul>
          <p className="title">MAIN</p>
          <Link to="/home" style={{ textDecoration: "none" }}>
            <li>
              <DashboardIcon className="icon" />
              <span>Dashboard</span>
            </li>
          </Link>
          <p className="title">LISTS</p>
          {/* patient registration */}
          {patientMenuPermission?.MenuName === "Patient" &&
            <>
              <ListItem button onClick={handleClick} className={classes.menuItem}>
                <ListItemIcon className={classes.menuItemIcon}>
                  <Person2OutlinedIcon />
                </ListItemIcon>
                <ListItemText primary="Patient" />
                {open ? <IconExpandLess /> : <IconExpandMore />}
              </ListItem>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Divider />
                <List component="div" disablePadding>
                  <ListItem button className={classes.menuItem}>
                    <Link to="/patient-registration" style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Patient List" /> </Link>
                  </ListItem>
                  <ListItem button className={classes.menuItem}>
                    <ListItemText inset primary="Billing" />
                  </ListItem>
                  {opdMenuPermission?.MenuName === "OPD" && <ListItem button className={classes.menuItem}>
                    <Link to="/opd-list" style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="OPD" /> </Link>
                  </ListItem>}
                  {ipdMenuPermission?.MenuName === "IPD" && <ListItem button className={classes.menuItem}>
                    <Link to="/ipd" style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="IPD" /> </Link>
                  </ListItem>}
                </List>
              </Collapse></>}
          {/* Master */}
          {MenuPermission?.MenuName === "Master" && <>
            <ListItem button onClick={handleMasterClick} className={classes.menuItem}>
              <ListItemIcon className={classes.menuItemIcon}>
                <IconLibraryBooks />
              </ListItemIcon>

              <ListItemText primary="Master" />
              {openMaster ? <IconExpandLess /> : <IconExpandMore />}
            </ListItem>
            <Collapse in={openMaster} timeout="auto" unmountOnExit>
              <Divider />
              <List component="div" disablePadding>
                <ListItem button className={classes.menuItem}>
                  <Link to="/master/branch" style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Branch" /></Link>
                </ListItem>
                <ListItem button className={classes.menuItem}>
                  <Link to="/master/department" style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Department" /></Link>
                </ListItem>
                <ListItem button className={classes.menuItem}>
                  <Link to="/master/diagnosis" style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Diagnosis" /></Link>
                </ListItem>
                <ListItem button className={classes.menuItem}>
                  <Link to="/master/doctor" style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Doctor" /></Link>
                </ListItem>
                <ListItem button className={classes.menuItem}>
                  <Link to="/master/room-type-table" style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Room Type" /></Link>
                </ListItem>
                <ListItem button className={classes.menuItem}>
                  <Link to="/master/Ward-list" style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Ward" /></Link>
                </ListItem>
                <ListItem button className={classes.menuItem}>
                  <Link to="/master/bed-list" style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Bed" /></Link>
                </ListItem>
                <ListItem button className={classes.menuItem}>
                  <Link to="/master/insurance-list" style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Insurance" /></Link>
                </ListItem>
                {/* <ListItem button className={classes.menuItem}>
                  <Link to="/master/card" style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Card" /></Link>
                </ListItem>
                <ListItem button className={classes.menuItem}>
                  <Link to="/master/package" style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Package" /></Link>
                </ListItem>
                <ListItem button className={classes.menuItem}>
                  <Link to="/master/referral" style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Referral" /></Link>
                </ListItem>
                <ListItem button className={classes.menuItem}>
                  <Link to="/master/vital-parameter" style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Vital Parameter	" /></Link>
                </ListItem> */}
                <ListItem button className={classes.menuItem}>
                  <Link to="/master/add-user" style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Add user" /></Link>
                </ListItem>
              </List>
            </Collapse> </>}
          {/* pharamacy */}
          {/* <ListItem button onClick={handlePharmacyClick} className={classes.menuItem}>
            <ListItemIcon className={classes.menuItemIcon}>
              <IconLibraryBooks />
            </ListItemIcon>
            <ListItemText primary="Pharmacy" />
            {openPharamacy ? <IconExpandLess /> : <IconExpandMore />}
          </ListItem>
          <Collapse in={openPharamacy} timeout="auto" unmountOnExit>
            <Divider />
            <List component="div" disablePadding>
              <ListItem button className={classes.menuItem}>
                <Link
                  // to="/pharmacy/pequisition"
                  style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Requisition" /></Link>
              </ListItem>
              <ListItem button className={classes.menuItem}>
                <Link
                  // to="/pharmacy/lab-entry"
                  style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Lab Entry" /></Link>
              </ListItem>
              <ListItem button className={classes.menuItem}>
                <Link
                  // to="/pharmacy/print-report" 
                  style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Print Report" /></Link>
              </ListItem>
            </List>
          </Collapse> */}
          {/* Pathalogy */}
           <ListItem button onClick={handlePathologyClick} className={classes.menuItem}>
            <ListItemIcon className={classes.menuItemIcon}>
              <IconLibraryBooks />
            </ListItemIcon>
            <ListItemText primary="Pathology" />
            {pathologyOpen ? <IconExpandLess /> : <IconExpandMore />}
          </ListItem>
            <Collapse in={pathologyOpen} timeout="auto" unmountOnExit>
              <Divider />
              <List component="div" disablePadding>
                <ListItem button className={classes.menuItem}>

                  <Link
                    to="/patient-registration"
                    style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Lab Request" /></Link>
                </ListItem>
                <ListItem button className={classes.menuItem}>
                  <Link
                    to="/pathology/lab-entery"
                    style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Lab Entry" /></Link>
                </ListItem>
                {/*
                <ListItem button className={classes.menuItem}>
                  <Link
                    to="/accounts/blocked-insurance"
                    style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Print Report" /></Link>
                </ListItem> */}
              </List>
            </Collapse>
          {/* Accounts */}
          {accountMenuPermission?.MenuName === "Account" && <> <ListItem button onClick={handleAccountsClick} className={classes.menuItem}>
            <ListItemIcon className={classes.menuItemIcon}>
              <IconLibraryBooks />
            </ListItemIcon>
            <ListItemText primary="Accounts" />
            {openAccounts ? <IconExpandLess /> : <IconExpandMore />}
          </ListItem>
            <Collapse in={openAccounts} timeout="auto" unmountOnExit>
              <Divider />
              <List component="div" disablePadding>
                <ListItem button className={classes.menuItem}>

                  <Link
                    to="/accounts/ipd-approval"
                    style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="IPD Approval" /></Link>
                </ListItem>
                <ListItem button className={classes.menuItem}>
                  <Link
                    to="/accounts/blocked-insurance"
                    style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Blocked Insurance" /></Link>
                </ListItem>
              </List>
            </Collapse></>}
          {/* Reports */}
          {reportMenuPermission?.MenuName === "Report" && <>    <ListItem button onClick={handleReportsClick} className={classes.menuItem}>
            <ListItemIcon className={classes.menuItemIcon}>
              <IconLibraryBooks />
            </ListItemIcon>
            <ListItemText primary="Reports" />
            {openReports ? <IconExpandLess /> : <IconExpandMore />}
          </ListItem>
            <Collapse in={openReports} timeout="auto" unmountOnExit>
              <Divider />
              <List component="div" disablePadding>
                <ListItem button className={classes.menuItem}>
                  <Link
                    to="/reports/inpatient-status-report" 
                    style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Inpatient Status Report" /></Link>
                </ListItem>
                {/* <ListItem button className={classes.menuItem}>
                  <Link
                    // to="/reports/doctor-list" 
                    style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Doctor List" /></Link>
                </ListItem>
                <ListItem button className={classes.menuItem}>
                  <Link
                    // to="/reports/hospital-rate-chart" 
                    style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Hospital Rate Chart" /></Link>
                </ListItem>
                <ListItem button className={classes.menuItem}>
                  <Link
                    // to="/reports/bed-report" 
                    style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Bed Report" /></Link>
                </ListItem>
                <ListItem button className={classes.menuItem}>
                  <Link
                    //  to="/reports/in-patient-discharge-report" 
                    style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="In Patient Discharge Report" /></Link>
                </ListItem>
                <ListItem button className={classes.menuItem}>
                  <Link
                    // to="/reports/outpatient-register" 
                    style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Outpatient Register" /></Link>
                </ListItem>

                <ListItem button className={classes.menuItem}>
                  <Link
                    // to="/reports/total-transaction"
                    style={{ textDecoration: "none", color: "black" }}><ListItemText inset primary="Total Transaction" /></Link>
                </ListItem> */}
              </List>
            </Collapse></>}
          {/* <li>
            <LocalHospitalOutlinedIcon className={classes.menuItemIcon} />
            <Link to="/opd-list" style={{ textDecoration: "none", color: "black" }}><span className='side-nav-names'>OPD</span></Link>
          </li>
          <li>
            <LocalHospitalOutlinedIcon className={classes.menuItemIcon} />
            <Link to="/ipd" style={{ textDecoration: "none", color: "black" }}><span className='side-nav-names'>IPD</span></Link>
          </li> */}
        </ul>
      </div>
      {/* <div className="bottom">
        <div
          className="colorOption"
          onClick={() => dispatch({ type: "LIGHT" })}
        ></div>
        <div
          className="colorOption"
          onClick={() => dispatch({ type: "DARK" })}
        ></div>
      </div> */}
    </div>
  );
};

export default Sidebar;
